import React, { Fragment } from 'react';
import Spinner from 'src/ui/library/Spinner/Spinner';
import ContentParser from 'src/ui/library/ContentParser';
import Button from 'src/ui/library/Button';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import { Edit } from '@material-ui/icons';
import intl from 'react-intl-universal';
import classNames from 'classnames';
import _ from 'lodash';

export default function EmployeeInfoPres(props) {
  const {
    employeeId,
    showCancelEditlModal,
    onCancelModal,
    onConfirmModal,
    isLoading,
    dynamicContent,
    onFormChange,
    onCancel,
    onEdit,
    onSave,
    isEditable,
    formData,
  } = props;

  const formClass = classNames({
    'profile-form-detail': true,
    editmode: isEditable,
  });

  if (isLoading) {
    return (
      <div style={{ marginTop: '10%' }}>
        <Spinner size={70} />
      </div>
    );
  }

  if (!dynamicContent || _.isEmpty(dynamicContent)) return null;

  return (
    <Fragment>
      {showCancelEditlModal && (
        <ConfirmDialog
          open
          title={intl.get('cases.details.messages.cancelTitle')}
          cancelText={intl.get('profile.details.buttons.cancelEdit')}
          confirmText={intl.get('profile.details.buttons.continueEdit')}
          onCancel={onCancelModal}
          onConfirm={onConfirmModal}>
          {intl.get('cases.details.messages.confirmMessage')}
        </ConfirmDialog>
      )}

      <section className={formClass}>
        <div className="form-parser">
          <ContentParser
            key={`${isEditable}-${employeeId}`}
            readOnly={!isEditable}
            data={dynamicContent}
            showLabels={false}
            numberOfColumns={3}
            debug={false}
            onChange={onFormChange}
          />
        </div>
      </section>
      <section className="profile-actions">
        {formData && isEditable ? (
          <div className="save-cancel-wrapper">
            <Button styleType="secondary" onClick={onCancel} className="action-button">
              {intl.get('profile.details.buttons.cancel')}
            </Button>
            <Button className="action-button" disabled={!formData.isFormComplete} onClick={onSave}>
              {intl.get('profile.details.buttons.save')}
            </Button>
          </div>
        ) : (
          <Fragment>
            <div className="edit-delete-wrapper">
              <a className="link" onClick={onEdit}>
                <Edit className="icon" /> <span className="text">{intl.get('profile.details.buttons.edit')}</span>
              </a>
            </div>
          </Fragment>
        )}
      </section>
    </Fragment>
  );
}
